<template>

  <div>
    <label v-if="titlebefore" class="titlebefore">{{ titlebefore }}</label>

    <label v-html="label"></label>
    <textarea v-html="value" :placeholder="label ? '' : name" @input="$emit('update', $event.target.value)">
      
    </textarea>
    <div class="remarks">{{ remarks }}</div>
  </div>
</template>

<script>
export default {
  props: ["value","label","name","remarks","titlebefore"],
   computed:{
   },
  model: {
    prop: "value",
    event: "update"
  }
};
</script>